module.exports = __webpack_public_path__ + "img/image9.3e74c8b6.png";